<template>
	<div class="teacher">
		<Ikns title="知识点基础信息">
			<el-form ref="dataForm" :model="formData" :rules="rules" label-position="left" label-width="100rem">
				<el-form-item label="所属学科" prop="subject_id">
					<el-select v-model="formData.subject_id" placeholder="请选择所属学科" @change="setRootName">
						<el-option v-for="i in subjectData" :label="i.subject_name" :value="Number(i.id)"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用学段" prop="apply_type">
					<el-radio-group v-model="formData.apply_type">
						<el-radio v-for="i in applyType" :key="i.value" :label="i.value">{{ i.label }}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</Ikns>

		<Ikns style="margin-top: 24rem" title="知识点内容">
      <editable-tree
          ref="tree"
          allow-empty
          node-default="知识点"
          :max-level="4"
          :max-name-length="150"
          :allow-drag="allowDrag"
          :allow-drop="allowDrop"
          :level-rule="levelRule"
          :props="defaultProps"
          :data="data">

      </editable-tree>

		</Ikns>

		<div style="margin-top: 40px">
			<el-button type="primary" @click="onSubmit">保存</el-button>
			<el-button @click="goBack">返回</el-button>
		</div>
	</div>
</template>

<script>
import EditableTree from "@/components/EditableTree";
import Ikns from "@/views/research/textbook/knowledge-point-management/Ikns.vue";
import {areArraysEqual, deepCopy} from "utils/l-tools";
import { zhPut, zhGet, zh_grade_year } from '@/api'


export default {
	_config: {"route": {"path": "edit", "meta": {"title": "编辑"}}},
	components: {Ikns,EditableTree},
	data() {
		return {//章节内容数据
      data:[
        {
          knowledge_name: '知识点',
          key:this.$tools.GUID(),
          knowledge_list: []
        }
      ],
      defaultProps:{
        label:"knowledge_name",
        children:"knowledge_list"
      },
      levelRule:[
        // 一级子树
        {
          editable:false, // 是否可编辑
          onlyDeleteChild:true, // 是否只删除子节点
          maxLength:50,    // 子节点最大长度, 设为-1 表示不限制
        },
        // 二级子树
        {
          maxLength: 10
        },
        // 三级子树
        {
          maxLength: 5
        },

      ],
			formData: {
				subject_id: "",
				apply_type: "",
				knowledge_list: [],
				knowledge_change: 0,
			},
			applyType: [],
			subjectData: [],
			rules: {
				subject_id: [
					{required: true, message: "请选择所属学科", trigger: "change"},
				],
				apply_type: [
					{required: true, message: "请选择应用学段", trigger: "change"},
				],
			},
			mes: "",
			editId: null,
			backData: [],
		};
	},
	methods: {
    setRootName(){
      let subject = (this.subjectData.find(item => item.id === this.formData.subject_id) || {}).subject_name||"";
      subject = subject ? `${subject}-` : "";
      this.data[0][this.defaultProps.label] = `${subject} 知识点`
    },

    removeEmptyKnowledgeList(arr) {
      let result = [];
      for (let i = 0; i < arr.length; i++) {
        let newObj = {...arr[i]};
        if (Array.isArray(newObj.knowledge_list) && newObj.knowledge_list.length > 0) {
          newObj.knowledge_list = this.removeEmptyKnowledgeList(newObj.knowledge_list);
        } else {
          delete newObj.knowledge_list;
        }
        result.push(newObj);
      }
      return result;
    },

    onSubmit() {
			this.$refs.dataForm.validate(valid => {
				if (valid) {
          this.formData.knowledge_list = this.data;
					this.formData.knowledge_change = areArraysEqual(this.backData, this.removeEmptyKnowledgeList(this.formData.knowledge_list)) ? 0 : 1;
					zhPut("/video/edit-knowledge", this.formData).then(() => {
						this.$message.success("修改成功");
						this.$router.back();
					});
				}
			});
		},
		goBack() {
			this.$router.go(-1);
		},
    // 判断节点能否被放置
    allowDrop(draggingNode, dropNode, type) {
      let curParentId = draggingNode.parent.id;
      let parentId = dropNode.parent.id;
      return parentId === curParentId && type !== 'inner';
    },
    // 判断节点能否被拖拽
    allowDrag(draggingNode) {
      return draggingNode.level !== 1;
    },
	},
	created() {
    zh_grade_year().then(res=>{
      this.applyType = res
    })
    zhGet('/video/subject').then(res=>{
      this.subjectData = res
    })
    zhGet('/video/get-knowledge',{id: this.$route.query.id}).then(res=>{
			this.formData = res;
      const list = this.formData.knowledge_list || [{ knowledge_name: '知识点', key:this.$tools.GUID(), knowledge_list: [] }]
			this.data = deepCopy(list);
			this.backData = deepCopy(this.formData.knowledge_list);
      this.$tools.DFS(this.data, (item) => {
        item.key = this.$tools.GUID();
       },{child:"knowledge_list"})
		});
	},
};
</script>

<style lang="scss" scoped>
.teacher {
	background: #F7F7F7 !important;
}

::v-deep .el-tree-node__content {
	height: 40rem !important;
}
</style>
